<div class="series-form-panel" [ngClass]="{ 'series-form-panel--active': settingsActice() }" matRipple (click)="onClickSettings()">
  <h4 class="series-form-panel__title">{{ name() }}</h4>

  <div class="series-form-panel__right">
    <mat-icon>settings</mat-icon>
    <h5 class="series-form-panel__settings">{{ 'anms.stats.options' | translate }}</h5>
  </div>
</div>

<div class="series-wrapper">
  <ng-container *ngIf="chartOptions() else loading">
    <h3 class="series-wrapper__text" *ngIf="empty(); else chart">
      {{ 'anms.stats.no_data' | translate }}
    </h3>

    <ng-template #chart>
      <highcharts-chart [Highcharts]="Highcharts"
                        class="series-wrapper__chart"
                        [options]="chartOptions()"
                        oneToOne="true">
      </highcharts-chart>
    </ng-template>
  </ng-container>

  <ng-template #loading>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
